
export const LogoutType = Object.freeze({
  SILENT: "SILENT",
  ANNOUNCE: "ANNOUNCE"
});


export const LOGOUT_BEGIN = "LOGOUT_BEGIN";
export const logoutBegin = (logoutType=LogoutType.ANNOUNCE) => ({
  type: LOGOUT_BEGIN,
  logoutType
});

export const LOGOUT_FAILED = "LOGOUT_FAILED";
export const logoutFailed = () => ({
  type: LOGOUT_FAILED,
});

export const LOGOUT_SUCCESS = "LOGOUT_SUCCESS";
export const logoutSuccess = () => ({
  type: LOGOUT_SUCCESS,
});
